import _objectSpread from "/var/www/commonsku/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
export function shallowClone(object) {
  return _objectSpread({}, object);
}
export function objectHasValue(object, value) {
  return Object.keys(object).some(function (key) {
    return object[key] === value;
  });
}
export function isEmptyObject(object) {
  return Object.keys(object).length === 0;
}
export function mapValues(object, fn) {
  var newObject = {};
  for (var _i = 0, _Object$keys = Object.keys(object); _i < _Object$keys.length; _i++) {
    var key = _Object$keys[_i];
    newObject[key] = fn(object[key]);
  }
  return newObject;
}